import { TICKET_AUDIT_ACTION_LABELS, type TicketHistoryItem } from '@gb-ticket/shared-types';

import { formatDateTime } from '@/lib/format';
import { PersonChip } from '@/platform/components/person-chip';

export function TicketTimeline({ items }: { items: TicketHistoryItem[] }) {
  const chronological = [...items].sort(
    (left, right) => new Date(left.createdAt).getTime() - new Date(right.createdAt).getTime(),
  );

  if (chronological.length === 0) {
    return <p className="text-sm text-muted-foreground">Noch keine Ereignisse.</p>;
  }

  return (
    <ol className="relative space-y-4 border-l-2 border-brand-navy/25 pl-4">
      {chronological.map((item) => (
        <li key={item.id} className="space-y-1">
          <div className="-ml-[1.45rem] flex items-center gap-2">
            <span
              className="mt-0.5 size-2.5 shrink-0 rounded-full border-2 border-background bg-brand-navy ring-2 ring-brand-navy/15"
              aria-hidden
            />
            <p className="text-sm font-medium text-primary">{titleFor(item)}</p>
          </div>
          <p className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
            <span>{formatDateTime(item.createdAt)}</span>
            {item.actor ? (
              <>
                <span>·</span>
                <PersonChip
                  displayName={item.actor.displayName}
                  profilePhotoUrl={item.actor.profilePhotoUrl}
                  avatarClassName="size-5"
                />
              </>
            ) : null}
          </p>
          {item.summary && <p className="text-sm whitespace-pre-wrap">{item.summary}</p>}
        </li>
      ))}
    </ol>
  );
}

function titleFor(item: TicketHistoryItem): string {
  if (item.action in TICKET_AUDIT_ACTION_LABELS) {
    return TICKET_AUDIT_ACTION_LABELS[item.action as keyof typeof TICKET_AUDIT_ACTION_LABELS];
  }
  return item.action;
}
